import React from 'react'
import { FunctionComponent } from 'react'
import './styles.scss'

type Props = {
  active?: boolean
  message: string
}

export const Tooltip: FunctionComponent<Props> = ({ active = false, message, children }) => {
  if (!active) {
    return <>{children}</>
  }

  return (
    <div className={'tooltip__wrapper'} data-tooltip={message}>
      {children}
    </div>
  )
}
